import { useComponentDidMount } from "../lib/hook";

export const useGetCampaignAndShows = ({ getCampaign, fetchPublicShowsByUUIDs }, campaignUUID) => {
  useComponentDidMount(() => {
    getCampaign(campaignUUID).then(resp => {
      if (resp.status === 200) {
        const showUUIDs = (resp.json?.items ?? []).map(({ item }) => item.showUUID);
        fetchPublicShowsByUUIDs(showUUIDs);
      }
    });
  }, []);
};
